<template>
    <div class="shipDetail-pcpCon" ref="experiencePart">
        <div class="shipDetail-pcpContainer">
            <div class="shipDetail-pcpMenuBg" ref="experienceBanner">
                <div class="pcpMenuBg-img" v-for="(category, i) in cruiseRoyalExperienceItems"
                :key="('categoryBanner_' + i)" v-show="currentCategory==category.category"
                >
                    <img :src="category.bannerImageUrl" :alt="category.contentTitle">
                    <div class="pcpMenuBg-imgTxt">
                        <div class="pcpMenuBg-imgTxtB">{{category.contentTitle}}</div>
                        <div>{{category.contentSubTitle}}</div>
                    </div>
                    <div class="pcpMenuBg-modelBg"></div>
                </div>
            </div>

            <div class="shipDetail-pcpMenuList">
                <div class="shipDetail-pcpMenu" v-for="(category, i) in cruiseRoyalExperienceItems"
                :key="('categoryMenu_' + i)" @click="onCategoryClick(category.category)"
                :class="{ active: currentCategory==category.category}">
                    <div class="pcpMenu-itemPic">
                        <img :src="getCategoryIcon(category.category)[0]" :alt="category.category">
                    </div>
                    <div class="pcpMenu-itemCon">
                        <div class="pcpMenu-itemIcon">
                            <img :src="getCategoryIcon(category.category)[1]" :alt="category.category">
                        </div>
                        <div class="pcpMenu-itemIconActive">
                            <img :src="getCategoryIcon(category.category)[2]" :alt="category.category">
                        </div>
                        <p class="pcpMenu-itemTxt">{{category.category}}</p>
                    </div>
                </div>
               
            </div>

            <ShipExperienceGroup 
                v-for="(category, i) in categories" :key="('itemGroup_' + i)"
                v-show="currentCategory==category"
                :items="getItemList(category)"
                :subCategories="getSubCategories(category)"
                :category="category"
                :onItemClick="showExperiencePopup"
                :isMenuFixed="isMenuFixed"
                :scrollToStart="scrollToStart"
            />

            <ShipExperiencePopup 
                :item="targetItem"
                :ships="ships"
                :itemList="productModel"
                :isShow="isShowExperiencePopup"
                :onClose="closeExperiencePopup"
            />

        </div>

        <div class="shipDetail-topMenu" v-show="isMenuFixed">
            <div class="topMenu-content">
                <ul>
                    <li v-for="(category, i) in cruiseRoyalExperienceItems"
                    :key="('categoryFixedMenu_' + i)" @click="onCategoryClick(category.category)"
                    :class="{ active: currentCategory==category.category}">
                        <div class="menuIcon">
                            <img class="imgT" :src="getCategoryIcon(category.category)[1]" :alt="category.category">
                            <img class="imgF" :src="getCategoryIcon(category.category)[2]" :alt="category.category">
                        </div>
                        <span>{{category.category}}</span>
                    </li>
                </ul>
            </div>
        </div>

    </div>
</template>

<script>
const ShipExperienceGroup = () => import('@/components/Ship/ShipExperienceGroup')
const ShipExperiencePopup = () => import('@/components/Ship/ShipExperiencePopup')
export default {
    name: "ShipExperience",
    components: {
        ShipExperienceGroup,
        ShipExperiencePopup
    },
    props: {
        productModel: {
            type: Array,
        },
        cruiseRoyalExperienceItems: {
            type: Array,
        },
        itemViewModels: {
            type: Array
        },
        ships: {
            type: Array
        }
    },
    data () {
        return {
            currentCategory: "",
            // 点击选中的item
            targetItem: {},
            isShowExperiencePopup: false,
            isMenuFixed: false
        }
    },
    beforeMount () {
        window.addEventListener("scroll", this.menuFixedHandler)
        window.addEventListener('hashchange', this.initCurrentCategory)
    },
    beforeDestroy () {
        window.removeEventListener("scroll", this.menuFixedHandler)
        window.removeEventListener("hashchange", this.initCurrentCategory)
    },
    methods: {
        getItemList (category) {
            return this.productModel.filter(r=>r.category==category)
        },
        getBanner (category) {
            return this.cruiseRoyalExperienceItems.find(r=>r.category == category) || {}
        },
        getSubCategories (category) {
            switch (category) {
                case '超凡美食': return ["免费餐厅", "收费餐厅", "酒吧", "其他餐饮服务"]
                case '超凡客房': return ["套房", "阳台房", "海景房", "内舱房"]
                case '超凡活动': return ["招牌演出", "休闲娱乐", "激情运动", "互动课程"]
                case '超凡童趣': return ["海上历奇", "梦工厂", "儿童游乐"]
                default: return ['']
            }
        },
        getCategoryIcon (category) {
            switch (category) {
                case '超凡美食': 
                    return ['https://resource.rcclchina.com.cn/rcclQN/image/shadowimg1.png'
                    ,'https://resource.rcclchina.com.cn/shipDetail/Food.png'
                    , 'https://resource.rcclchina.com.cn/shipDetail/FoodHover.png']
                case '超凡客房': 
                    return ['https://resource.rcclchina.com.cn/rcclQN/image/shadowimg2.png'
                    , 'https://resource.rcclchina.com.cn/shipDetail/guestRoom.png'
                    , 'https://resource.rcclchina.com.cn/shipDetail/guestRoomHover.png']
                case '超凡活动':
                    return ['https://resource.rcclchina.com.cn/QN%E7%BE%8E%E9%A3%9F/%E8%B6%85%E5%87%A1%E6%B4%BB%E5%8A%A8%20(1).jpg'
                    , 'https://resource.rcclchina.com.cn/shipDetail/entertainments.png'
                    , 'https://resource.rcclchina.com.cn/shipDetail/entertainmentsHover.png']
                case '超凡购物':
                    return ['https://resource.rcclchina.com.cn/QN%E7%BE%8E%E9%A3%9F/%E8%B6%85%E5%87%A1%E8%B4%AD%E7%89%A9%20(1).jpg'
                    , 'https://resource.rcclchina.com.cn/shipDetail/shopping.png'
                    , 'https://resource.rcclchina.com.cn/shipDetail/shoppingHover.png']
                case '超凡童趣':
                    return ['https://resource.rcclchina.com.cn/rcclQN/image/shadowimg7.png'
                    , 'https://resource.rcclchina.com.cn/shipDetail/childimg.png'
                    , 'https://resource.rcclchina.com.cn/shipDetail/childimgHover.png']
                case '超凡设施':
                    return ['https://resource.rcclchina.com.cn/rcclQN/image/facitilies143x273.png'
                    , 'https://resource.rcclchina.com.cn/rcclQN/image/facitiliesimg3.png'
                    , 'https://resource.rcclchina.com.cn/rcclQN/image/facitiliesimg4.png']
                default:
                    return ['', '', '']
            }
        },
        showExperiencePopup (item) {
            const itemViewModel = this.itemViewModels.find(r=>r.id == item.id)
            if (!itemViewModel) {
                return
            }
            this.targetItem = itemViewModel
            this.targetItem.vrUrl = item.vrUrl
            this.isShowExperiencePopup = true
        },
        closeExperiencePopup () {
            this.targetItem = {}
            this.isShowExperiencePopup = false
        },
        menuFixedHandler () {
            const scrollTop = window.scrollY
            const experienceBanner = this.$refs.experienceBanner
            const experiencePart = this.$refs.experiencePart
            const targetTop = experienceBanner.offsetTop + experienceBanner.offsetHeight + experiencePart.offsetTop 
            if (scrollTop >= targetTop) {
                this.isMenuFixed = true
            } else {
                this.isMenuFixed = false
            }
        },
        onCategoryClick (category) {
            this.currentCategory = category
            this.scrollToStart()
        },
        //页面滚动至Item开始的地方
        scrollToStart () {
            const scrollTop = window.scrollY
            const experienceBanner = this.$refs.experienceBanner
            const experiencePart = this.$refs.experiencePart
            const targetTop = experienceBanner.offsetTop + experiencePart.offsetTop
            if (scrollTop > targetTop) {
                window.scroll({
                    top: targetTop,
                    behavior: "smooth"
                })
            }
        },
        initCurrentCategory () {
            if (this.cruiseRoyalExperienceItems.length > 0) {
                let menuIndex = 0
                let urlHash = this.$router.currentRoute.hash + ""
                if (urlHash && urlHash.length > 0) {
                    urlHash = urlHash.toLowerCase()
                    switch (urlHash) {
                        case "#food":
                            menuIndex = 0; break;
                        case "#room":
                            menuIndex = 1; break;
                        case "#activity":
                            menuIndex = 2; break;
                        case "#shopping":
                            menuIndex = 3; break;
                        case "#kid":
                            menuIndex = 4; break;
                        case "#entertainment":
                            menuIndex = 5; break;
                        default:
                            break;
                    }
                }
                if (menuIndex < this.cruiseRoyalExperienceItems.length) {
                    this.currentCategory = this.cruiseRoyalExperienceItems[menuIndex].category
                } else {
                    this.currentCategory = this.cruiseRoyalExperienceItems[0].category
                }
            }
        }
    },
    computed: {
        categories () {
            return this.cruiseRoyalExperienceItems.map(r=>r.category)
        }
    },
    watch: {
        cruiseRoyalExperienceItems () {
            this.initCurrentCategory()
        }
    }
}
</script>

<style lang="less" scoped>
img {
    width: 100%;
}
.shipDetail-pcpCon {
    background-color: #fff;
    padding-bottom: 15px;
    .shipDetail-pcpContainer {
        position: relative;
    }
    .shipDetail-pcpMenuBg {
        width: 100%;
        height: 188px;
        overflow: hidden;
        .pcpMenuBg-img {
            position: relative;
            width: 100%;
            height: 100%;
            img {
                width: 112%;
            }
        }
        .pcpMenuBg-imgTxt {
            position: absolute;
            top: 40px;
            left: 50%;
            width: 352px;
            text-align: center;
            margin-left: -176px;
            font-size: 12px;
            color: #fff;
            letter-spacing: 1px;
            z-index: 33;
            .pcpMenuBg-imgTxtB {
                font-size: 15px;
                margin-bottom: 2px;
            }
        }
        .pcpMenuBg-modelBg {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            background-color: rgba(0,0,0,.3);
        }
    }

    .shipDetail-pcpMenuList {
        overflow: hidden;
        padding: 0 3.2%;
        margin-top: -92px;
        text-align: center;
        display: flex;
        justify-content: center;
        .shipDetail-pcpMenu {
            width: 15.1%;
            position: relative;
            float: left;
            .pcpMenu-itemPic {
                width: 100%;
                height: 120px;
                overflow: hidden;
                img {
                    width: 140%;
                }
            }
            .pcpMenu-itemCon {
                background-color: rgba(0,0,0,.7);
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 120px;
                .pcpMenu-itemIcon {
                    margin: 0 auto;
                    margin-top: 35px;
                    width: 34.286%;
                    height: 17px;
                }
                .pcpMenu-itemIconActive {
                    margin: 0 auto;
                    margin-top: 35px;
                    width: 20.455%;
                    height: 17px;
                    display: none;
                }
                .pcpMenu-itemTxt {
                    margin-top: 9px;
                    font-size: 12px;
                    color: #fff;
                    text-align: center;
                    transform: scale(.95);
                    -webkit-transform: scale(.95);
                    -moz-transform: scale(.95);
                    -o-transform: scale(.95);
                }
            }
        }
        .shipDetail-pcpMenu.active {
            width: 24.333%;
            float: left;
            .pcpMenu-itemCon {
                background-color: rgba(240,175,17,.9);
                .pcpMenu-itemIcon {
                    display: none;
                }
                .pcpMenu-itemIconActive {
                    display: block;
                }
                .pcpMenu-itemTxt {
                    font-size: 13px;
                    color: #000;
                    font-weight: bolder;
                }
            }
        }
    }

    .shipDetail-topMenu {
        position: fixed;
        width: 100%;
        top: 50px;
        z-index: 20;
        .topMenu-content {
            background: #f2f2ef;
            text-align: center;
            ul {
                width: 100%;
                overflow: hidden;
                li {
                    font-size: 12px;
                    width: 55px;
                    height: 53px;
                    float: left;
                    .menuIcon {
                        width: 100%;
                        height: 24px;
                        overflow: hidden;
                        margin-top: 3px;
                        margin-bottom: 3px;
                    }
                    span {
                        transform: scale(.9);
                        -webkit-transform: scale(.9);
                        -moz-transform: scale(.9);
                        -o-transform: scale(.9);
                    }
                    img {
                        width: 19px;
                        margin: 0 auto;
                        vertical-align: -webkit-baseline-middle;
                    }
                    .imgF {
                        display: none;
                    }
                    .imgT {
                        display: inline-block;
                    }
                }
                li.active {
                    width: 99px;
                    background: #f1af12;
                    font-size: 13px;
                    font-weight: 600;
                    .menuIcon {
                        margin-bottom: 1px;
                    }
                    span {
                        transform: scale(1);
                        -webkit-transform: scale(1);
                        -moz-transform: scale(1);
                        -o-transform: scale(1);
                    }
                    .imgF {
                        display: inline-block;
                    }
                    .imgT {
                        display: none;
                    }
                }
            }
        }
    }
}
</style>